// Deprecated: Use useNotifications hook instead
// This file is kept for backwards compatibility but will be removed

import { useNotifications } from "./useNotifications";

// Re-export the new hook for backwards compatibility
export const showNotification = (data: any) => {
  console.warn("showNotification is deprecated. Use useNotifications hook instead.");
  // Provide basic fallback
};

export const clearNotificationCache = () => {
  console.warn("clearNotificationCache is deprecated. Use useNotifications().clearCache() instead.");
};

export const getNotificationStats = () => {
  console.warn("getNotificationStats is deprecated.");
  return { total: 0, details: {} };
};

// For backwards compatibility, export the new hook
export { useNotifications };